import { render, staticRenderFns } from "./OrderReportPage.vue?vue&type=template&id=6ccb5538&"
import script from "./OrderReportPage.vue?vue&type=script&lang=js&"
export * from "./OrderReportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports